import React, { FC, ReactNode } from "react";
import { cn } from "@/lib/utils";
import { DashboardWidgetHeader } from "@/components/pages/dashboard/components/DashboardWidgetHeader";
import { Card, CardContent } from "@/components/ui/card";

interface Props {
  className?: string;
  contentClassName?: string;
  icon: ReactNode;
  title: string;
  value?: number | string;
  children: ReactNode;
  badgeNode?: ReactNode;
  endNode?: ReactNode;
}

export const DashboardVidgetContainer: FC<Props> = ({
  className,
  contentClassName,
  icon,
  title,
  value,
  children,
  badgeNode,
  endNode,
}) => {
  return (
    <Card
      className={cn(
        "flex h-full min-h-0 w-full min-w-0 flex-col gap-2 rounded-2xl border-zinc-200 bg-white py-0 font-geist text-neutral-900 shadow-none",
        className,
        "overflow-visible",
      )}
    >
      <div className="relative z-10 shrink-0 overflow-visible">
        <DashboardWidgetHeader
          icon={icon}
          title={title}
          value={value}
          badgeNode={badgeNode}
          endNode={endNode}
        />
      </div>
      <CardContent
        className={cn(
          "relative flex min-h-0 flex-1 flex-col overflow-y-auto p-0",
          contentClassName,
        )}
      >
        {children}
      </CardContent>
    </Card>
  );
};
